var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-button',{attrs:{"disabled":!_vm.isConnectionOk},on:{"click":_vm.openScheduler}},[_c('font-awesome-icon',{attrs:{"icon":"calendar"}})],1),_c('scheduler-modal',{ref:"schedulerModal",attrs:{"settings-var":_vm.getSingleVar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }